import React from 'react';

import Badge from '../common/Badge';
import { Button } from '@copilot/ui';

const STATUS_CONFIG = {
  starting: { variant: 'reconnecting', dot: true, label: 'Connecting...' },
  awaiting_tab_selection: {
    variant: 'paused',
    dot: true,
    label: 'Waiting for meeting audio',
  },
  awaiting_mic_start: {
    variant: 'paused',
    dot: true,
    label: 'Tap Start Listening',
  },
  listening: { variant: 'listening', dot: true, label: 'Listening...' },
  paused: { variant: 'paused', dot: true, label: 'Paused' },
  reconnecting: {
    variant: 'reconnecting',
    dot: true,
    label: 'Reconnecting...',
  },
  disconnected: {
    variant: 'disconnected',
    dot: true,
    label: 'Disconnected',
  },
};

// Shown once the backend has confirmed this meeting already ended
// (LiveMeetingPage sets meetingEnded=true) — a terminal state with no
// further valid action, so Pause/Resume/End are replaced by a plain
// label rather than buttons that would just fail lifecycle validation.
const MEETING_ENDED_CONFIG = { variant: 'disconnected', dot: false, label: 'Meeting Ended' };

function StatusBar({
  status,
  meetingEnded,
  reconnectAttempt,
  maxReconnectAttempts,
  onPause,
  onResume,
  onEndMeeting,
}) {
  const baseConfig = meetingEnded
    ? MEETING_ENDED_CONFIG
    : STATUS_CONFIG[status] || STATUS_CONFIG.disconnected;

  // "Reconnecting... Attempt 2/5" instead of a bare "Reconnecting..." —
  // reconnectAttempt/maxReconnectAttempts are optional so this component
  // still works standalone (e.g. in isolation/tests) without them.
  const config =
    status === 'reconnecting' && reconnectAttempt && maxReconnectAttempts
      ? {
          ...baseConfig,
          label: `Reconnecting... Attempt ${reconnectAttempt}/${maxReconnectAttempts}`,
        }
      : baseConfig;

  return (
    <div className="live-meeting-footer">
      <Badge variant={config.variant} dot={config.dot}>
        {config.label}
      </Badge>

      <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
        {!meetingEnded && (
          status === 'paused' ? (
            <Button variant="secondary" onClick={onResume}>
              Resume
            </Button>
          ) : (
            <Button
              variant="secondary"
              onClick={onPause}
              disabled={status === 'disconnected'}
            >
              Pause
            </Button>
          )
        )}

        <Button variant="danger" onClick={onEndMeeting} disabled={meetingEnded}>
          {meetingEnded ? 'Meeting Ended' : 'End Meeting'}
        </Button>
      </div>
    </div>
  );
}

export default StatusBar;
